export const types = ['A01', 'A02', 'B01'] as const
export type TType = typeof types[number]

export const typeLabel: Record<TType, string> = {
  'A01': 'がんリスク検査',
  'A02': '認知リスク検査',
  'B01': 'がんリスク検査・認知リスク検査'
}
